import Vue from "vue";
import { Promise } from "core-js";
import i18n from "../../i18n";
import { normalize } from "../../helpers/pagination";
import { makePublicInsightApiRequest } from "../../helpers/request";

const state = {
  contacts: {
    isBusy: false,
    data: null,
    pagination: null,
    error: null
  },
  contact: {
    isBusy: false,
    data: null,
    error: null,
    addIsBusy: false,
    removeIsBusy: false,
  },
  contact_lists: {
    isBusy: false,
    data: null,
    error: null
  },
  contact_list: {
    isBusy: false,
    data: null,
    error: null,
    addIsBusy: false,
    removeIsBusy: false,
  },
  contactsBusy: null,
  contactListsBusy: null,
};

const getIdsToRemove = (payload) => payload.map(item => item.id);

const removeByIds = (dataArray, idsToRemove) => dataArray.filter(item => !idsToRemove.includes(item.id));

const mutations = {
  LOAD_CONTACTS_BUSY: (state, payload) => {
    state.contacts.isBusy = payload;
  },

  LOAD_CONTACTS_PAGINATION: (state, payload) => {
    state.contacts.pagination = payload;
  },

  LOAD_CONTACTS_SUCCESS: (state, payload) => {
    state.contacts.data = payload;
    state.contacts.error = null;
  },

  LOAD_CONTACTS_FAIL: (state, payload) => {
    state.contacts.data = null;
    state.contacts.error = payload;
  },

  LOAD_CONTACT_BUSY: (state, payload) => {
    state.contact.isBusy = payload;
  },

  LOAD_CONTACT_SUCCESS: (state, payload) => {
    state.contact.data = payload;
    state.contact.error = null
  },

  LOAD_CONTACT_FAIL: (state, payload) => {
    state.contact.data = null;
    state.contact.error = payload;
  },

  LOAD_CONTACT_LISTS_BUSY: (state, payload) => {
    state.contact_lists.isBusy = payload;
  },

  LOAD_CONTACT_LISTS_SUCCESS: (state, payload) => {
    state.contact_lists.data = payload;
    state.contact_lists.error = null;
  },

  LOAD_CONTACT_LISTS_FAIL: (state, payload) => {
    state.contact_lists.data = null;
    state.contact_lists.error = payload;
  },

  REMOVE_CONTACT_LIST_SUCCESS: (state, payload) => {
    const updatedContactLists = state.contact_lists.data.data.filter(contactList => contactList.id !== payload);
    state.contact_lists.data = {
      ...state.contact_lists.data,
      data: updatedContactLists
    };
  },

  LOAD_CONTACT_LIST_BUSY: (state, payload) => {
    state.contact_list.isBusy = payload;
  },

  LOAD_CONTACT_LIST_SUCCESS: (state, payload) => {
    state.contact_list.data = payload;
    state.contact_list.error = null;
  },

  LOAD_CONTACT_LIST_FAIL: (state, payload) => {
    state.contact_list.data = null;
    state.contact_list.error = payload;
  },

  CLEAR_CONTACTS: (state, payload) => {
    state.contacts.data = [];
  },

  CLEAR_CONTACT_LISTS: (state, payload) => {
    state.contact_lists.data = [];
  },

  CONTACT_LIST_CONTACTS_ADD_BUSY: (state) => {
    state.contact_list.addIsBusy = true;
  },

  CONTACT_LIST_CONTACTS_ADD_SUCCESS: (state, payload) => {
    state.contact_list.addIsBusy = false;
    const existingContacts = state.contact_list.data.contacts;
    const combinedContacts = [
      ...existingContacts,
      ...payload
    ];
    
    //remove duplicates
    state.contact_list.data.contacts = Array.from(
      new Set(combinedContacts.map(contact => contact.id))
    ).map(id => combinedContacts.find(contact => contact.id === id));

    const idsToRemove = getIdsToRemove(payload);
    state.contacts.data = removeByIds(state.contacts.data, idsToRemove);
  },

  CONTACT_LIST_CONTACTS_ADD_FAIL: (state, payload) => {
    state.contact_list.error = payload
    state.contact_list.addIsBusy = false;
  },

  CONTACT_LIST_CONTACTS_REMOVE_BUSY: (state) => {
    state.contact_list.removeIsBusy = true;
  },

  CONTACT_LIST_CONTACTS_REMOVE_SUCCESS: (state, payload) => {
    const idsToRemove = payload.map(contact => contact.id);
    state.contact_list.data.contacts = state.contact_list.data.contacts.filter(contact => !idsToRemove.includes(contact.id));
    state.contact_list.removeIsBusy = false;
  },  

  CONTACT_LIST_CONTACTS_REMOVE_FAIL: (state, payload) => {
    state.contact_list.error = payload;
    state.contact_list.removeIsBusy = false;
  },

  CONTACT_CONTACT_LISTS_ADD_BUSY: (state) => {
    state.contact.addIsBusy = true;
  },

  CONTACT_CONTACT_LISTS_ADD_SUCCESS: (state, payload) => {
    state.contact.addIsBusy = false;
    const existingContactLists = state.contact.data.data.contact_lists;
    const combinedContactLists = [
      ...existingContactLists,
      ...payload
    ];

    //remove duplicates
    state.contact.data.data.contact_lists = Array.from(
      new Set(combinedContactLists.map(contactList => contactList.id))
    ).map(id => combinedContactLists.find(contactList => contactList.id === id));

    const idsToRemove = getIdsToRemove(payload);
    state.contact_lists.data.data = removeByIds(state.contact_lists.data.data, idsToRemove);
  },

  CONTACT_CONTACT_LISTS_ADD_FAIL: (state, payload) => {
    state.contact.error = payload;
    state.contact.addIsBusy = false;
  },

  CONTACT_CONTACT_LISTS_REMOVE_BUSY: (state) => {
    state.contact.removeIsBusy = true;
  },

  CONTACT_CONTACT_LISTS_REMOVE_SUCCESS: (state, payload) => {
    const idsToRemove = payload.map(contactList => contactList.id);
    state.contact.data.data.contact_lists = state.contact.data.data.contact_lists.filter(contactList => !idsToRemove.includes(contactList.id));
    state.contact.removeIsBusy = false;
  },

  CONTACT_CONTACT_LISTS_REMOVE_FAIL: (state, payload) => {
    state.contact.error = payload;
    state.contact.removeIsBusy = false;
  }
};

const actions = {
  getMobileAppContacts: ({ commit, state }, { pagination, routeQuery, withLists, excludeFromContactList }) => {
    return new Promise((resolve, reject) => {
      if (state.contacts.isBusy == false) {
        commit("LOAD_CONTACTS_BUSY", true);

        let query = `?lists_extended=true&with_lists=${withLists}&`;
        if (excludeFromContactList) query += `exclude_from_contact_list=${excludeFromContactList}&`;
        const normalizedPagination = normalize(pagination);
        Object.keys(normalizedPagination).map((param, i) => {
          query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
        })

        const searchQuery = Object.values(routeQuery).join('');
        if (searchQuery) {
          query += `&search=${encodeURIComponent(searchQuery)}`;
        }
        return makePublicInsightApiRequest({ url: `/v4/rta/mobile_app/contacts${query}`, method: "GET" })
          .then(response => {
            const res = response.data.data;
            commit("LOAD_CONTACTS_PAGINATION", res.pagination)
            let payload = {};
            if (pagination.page == 1) {
              payload = res.data;
            } else {
              const contacts = Array.isArray(state.contacts.data) ? state.contacts.data : [];
              payload = Object.assign({}, res.data, { data: [...contacts, ...res.data] }).data;
            }
            commit("LOAD_CONTACTS_SUCCESS", payload);
            resolve();
          })
          .catch(error => {
            Vue.notify({
              group: "store_notifications",
              type: "error",
              text: i18n.t("messages.request.error")
            });
            commit("LOAD_CONTACTS_FAIL", error)
            reject();
          })
          .finally(() => commit("LOAD_CONTACTS_BUSY", false));
      }
    });
  },

  getContact: ({ commit, state }, { contactId, withExtendedLists, includeDevices, order, sort }) => {
    return new Promise((resolve, reject) => {
      commit("LOAD_CONTACT_BUSY", true);

      let query = withExtendedLists ? '?lists_extended=true' : '';
      if (includeDevices) {
        query += '&with_devices=true';
      }
      if (order && sort) {
        query += `&order_by=${order}&sort=${sort}`;
      }

      return makePublicInsightApiRequest({ url: `/v4/rta/mobile_app/contacts/${contactId}${query}`, method: "GET" })
        .then(response => {
          commit("LOAD_CONTACT_SUCCESS", response.data);
          resolve();
        })
        .catch(error => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });
          commit("LOAD_CONTACT_FAIL", error);
          reject();
        })
        .finally(() => commit("LOAD_CONTACT_BUSY", false));
    });
  },

  addBatchContactListsToContact: ({ commit }, { contactLists, contact}) => {
    return new Promise((resolve, reject) => {
      if(contactLists.length == 0) {
        resolve();
        return;
      }

      commit("CONTACT_CONTACT_LISTS_ADD_BUSY");

      const body = {
        contactLists: contactLists.map(list => list.id)
      }

      makePublicInsightApiRequest({ url: `v4/rta/mobile_app/contacts/${contact.id}/contact_lists`, data: body, method: "PUT" })
      .then(response => {
        if (response.status === 205) {
          commit("CONTACT_CONTACT_LISTS_ADD_SUCCESS", contactLists);
          
          Vue.notify({
            group: "store_notifications",
            type: "success",
            text: i18n.t("messages.mobile_app.contact_list_contact_insert_success")
          });
        } else {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.mobile_app.contact_insert_error")
          });
          commit("CONTACT_CONTACT_LISTS_ADD_FAIL", i18n.t("messages.mobile_app.contact_insert_error"));
        }
        resolve();
        
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });
        commit("CONTACT_CONTACT_LISTS_ADD_FAIL", i18n.t("messages.request.error"));
        resolve();
      })
    })
  },

  removeBatchContactListsFromContact: ({ commit }, { contactLists, contact }) => {
    
    return new Promise((resolve, reject) => {
      if(contactLists.length == 0) {
        resolve();
        return;
      }
      commit("CONTACT_CONTACT_LISTS_REMOVE_BUSY");

      const body = {
        contactLists:  contactLists.map(list => list.id)
      }

      return makePublicInsightApiRequest({ url: `v4/rta/mobile_app/contacts/${contact.id}/contact_lists`, data: body, method: "DELETE" })
        .then(response => {
          if (response.status === 205) {
            Vue.notify({
              group: "store_notifications",
              type: "success",
              text: i18n.t("messages.mobile_app.contact_list_contact_delete_success")
            });
            commit("CONTACT_CONTACT_LISTS_REMOVE_SUCCESS", contactLists);
          } else {
            Vue.notify({
              group: "store_notifications",
              type: "error",
              text: i18n.t("messages.mobile_app.contact_list_contact_delete_error")
            });
            commit("CONTACT_CONTACT_LISTS_REMOVE_FAIL", i18n.t("messages.mobile_app.contact_list_contact_delete_error"));
          }
          resolve();
        })
        .catch(_ => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });
          commit("CONTACT_CONTACT_LISTS_REMOVE_FAIL", i18n.t("messages.mobile_app.contact_list_contact_delete_error"));
          resolve();
        })
    })
  },

  getContactLists: ({ commit, state }, { pagination, routeQuery, excludeFromContact }) => {
    return new Promise((resolve, reject) => {
      commit("LOAD_CONTACT_LISTS_BUSY", true);
      commit("LOAD_CONTACTS_SUCCESS", null);
      let query = "?";
      const normalizedPagination = normalize(pagination);
      Object.keys(normalizedPagination).map((param, i) => {
        query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
      });

      const searchQuery = Object.values(routeQuery).join('');
      if (searchQuery) {
        query += `&search=${encodeURIComponent(searchQuery)}`;
      }
      if (excludeFromContact) {
        query += `&exclude_from_contact=${excludeFromContact}`;
      }

      return makePublicInsightApiRequest({ url: `/v4/rta/mobile_app/contact_lists${query}`, method: "GET" })
        .then(response => {
          const res = response.data;
          let payload = {};
          if (pagination.page <= 1) {
            payload = res.data;

          } else {
            const contactLists = state.contact_lists.data.data;
            payload = Object.assign({}, res.data, { data: [...contactLists, ...res.data.data] });
          }
          commit("LOAD_CONTACT_LISTS_SUCCESS", payload);
          resolve();
        })
        .catch(error => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });
          commit("LOAD_CONTACT_LISTS_FAIL", error);
          reject();
        })
        .finally(() => commit("LOAD_CONTACT_LISTS_BUSY", false));
    });
  },

  getContactList: ({ commit }, { contactListId }) => {
    return new Promise((resolve, reject) => {
      commit("LOAD_CONTACT_LIST_BUSY", true);
      commit("LOAD_CONTACTS_SUCCESS", null);
      return makePublicInsightApiRequest({ url: `/v4/rta/mobile_app/contact_lists/${contactListId}`, method: "GET" })
        .then(response => {
          commit("LOAD_CONTACT_LIST_SUCCESS", response.data.data);
          resolve();
        })
        .catch(error => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });
          commit("LOAD_CONTACT_LIST_FAIL", error);
          reject();
        })
        .finally(() => commit("LOAD_CONTACT_LIST_BUSY", false));
    });
  },

  updateContactListName: ({ commit }, { contactListId, name }) => {
    const body = {
      name
    };
    return makePublicInsightApiRequest({ url: `/v4/rta/mobile_app/contact_lists/${contactListId}`, data: body, method: "PATCH" })
      .then(_ => {
        Vue.notify({
          group: "store_notifications",
          type: "success",
          text: i18n.t("messages.mobile_app.contact_list_edit_success")
        });
      })
      .catch(_ => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });
      });
  },

  removeBatchContactsFromContactList: ({ commit }, { contactList, contacts }) => {
    return new Promise((resolve, reject) => {
      if(contacts.length === 0) {
        resolve();
        return;
      }
      commit("CONTACT_LIST_CONTACTS_REMOVE_BUSY");

      const body = {
        contacts: contacts.map(contact => contact.id)
      }

      const contactListId = contactList.id;
      return makePublicInsightApiRequest({ url: `/v4/rta/mobile_app/contact_lists/${contactListId}/contacts`, data: body, method: "DELETE" })
        .then(response => {
          if (response.status === 205) {
            Vue.notify({
              group: "store_notifications",
              type: "success",
              text: i18n.t("messages.mobile_app.contact_list_contact_delete_success")
            });
            commit("CONTACT_LIST_CONTACTS_REMOVE_SUCCESS", contacts);
          } else {
            Vue.notify({
              group: "store_notifications",
              type: "error",
              text: i18n.t("messages.mobile_app.contact_list_contact_delete_error")
            });
          }
          commit("CONTACT_LIST_CONTACTS_REMOVE_FAIL", i18n.t("messages.mobile_app.contact_list_contact_delete_error"));
          resolve();
        })
        .catch(_ => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });
          commit("CONTACT_LIST_CONTACTS_REMOVE_FAIL", i18n.t("messages.mobile_app.contact_list_contact_delete_error"));
          resolve();
        })
    })
  },

  addBatchContactsToContactList({ commit }, { contactList, contacts }) {
    return new Promise((resolve, reject) => {
      
      if(contacts.length == 0) {
        resolve();
        return;
      }
      commit("CONTACT_LIST_CONTACTS_ADD_BUSY");
  
      const body = {
        contacts: contacts.map(contact => contact.id)
      }

      makePublicInsightApiRequest({ url: `v4/rta/mobile_app/contact_lists/${contactList.id}/contacts`,data: body, method: "PUT" })
      .then(response => {
        if (response.status === 205) {
          Vue.notify({
            group: "store_notifications",
            type: "success",
            text: i18n.t("messages.mobile_app.contact_list_contact_insert_success")
          });
          commit("CONTACT_LIST_CONTACTS_ADD_SUCCESS", contacts);
        } else {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.mobile_app.contact_insert_error")
          });
          commit("CONTACT_LIST_CONTACTS_ADD_FAIL", i18n.t("messages.mobile_app.contact_insert_error"));
        }
        resolve();
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });
        commit("CONTACT_LIST_CONTACTS_ADD_FAIL", i18n.t("messages.mobile_app.contact_insert_error"));
        resolve();
      })
    })
  },

  deleteContactList: ({ commit }, { contactListId }) => {
    return makePublicInsightApiRequest({ url: `/v4/rta/mobile_app/contact_lists/${contactListId}`, method: "DELETE" })
      .then(response => {
        if (response.status === 205) {
          Vue.notify({
            group: "store_notifications",
            type: "success",
            text: i18n.t("messages.mobile_app.contact_list_delete_success")
          });
          commit("REMOVE_CONTACT_LIST_SUCCESS", contactListId);
        } else {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.mobile_app.contact_list_delete_error")
          });
          commit("LOAD_CONTACT_LISTS_FAIL");
        }
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });
        commit("LOAD_CONTACT_LISTS_FAIL", error);
      });
  },

  createContactList: ({ commit }, { name, organization_uid, project_uid }) => {
    return new Promise((resolve, reject) => {
      const body = {
        name: name,
        organization_uid: organization_uid,
        project_uid: project_uid
      };
      return makePublicInsightApiRequest({ url: `/v4/rta/mobile_app/contact_lists`, data: body, method: "POST" })
        .then(response => {
          if (response.status === 200) {
            Vue.notify({
              group: "store_notifications",
              type: "success",
              text: i18n.t("messages.mobile_app.contact_list_create_success")
            });
            resolve(response.data.data.id);
          } else {
            Vue.notify({
              group: "store_notifications",
              type: "error",
              text: i18n.t("messages.mobile_app.contact_list_delete_error")
            });
            reject();
          }
        })
        .catch(_ => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });
          reject();
        });
    });
  },

  clearContactLists: ({ commit }) => {
    commit("CLEAR_CONTACT_LISTS");
  },

  clearContacts: ({ commit }) => {
    commit("CLEAR_CONTACTS");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};